import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { Contact } from "@/components/site/Contact";
import { Beach } from "@/components/site/Beach";
import { LamellareFaq } from "@/components/site/LamellareFaq";
import { useT } from "@/i18n";
import { usePageMeta } from "@/lib/pageMeta";

export default function StabilimentiBalneari() {
  const t = useT();
  usePageMeta({
    title: t("beachPage.metaTitle", "Stabilimenti balneari prefabbricati in legno"),
    desc: t("beachPage.metaDesc", "Emma Industrie progetta e produce stabilimenti balneari prefabbricati in legno: bar, ristoranti, chioschi, cabine e spogliatoi, strutture fisse tutto l'anno in legno trattato per l'ambiente marino."),
    path: "/stabilimenti-balneari",
    image: "/og-balneari.jpg",
  });
  return (
    <div className="bg-[#0E2A33]" data-testid="beach-page">
      <Nav />
      <main className="pt-24">
        <div className="keep-dark mx-auto max-w-[1500px] px-5 pt-10 sm:px-8">
          <Link to="/" className="tap inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#D5DEDF] transition-colors duration-300 hover:text-[#E8C79A]" data-testid="beach-page-back">
            <ArrowLeft className="h-4 w-4" /> {t("beachPage.back", "Torna alla home")}
          </Link>
        </div>
        <Beach full />
        <LamellareFaq dataKey="faqBeach" titleKey="beachPage.faqH" title="Domande frequenti sugli stabilimenti balneari" />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
